import React, { useEffect, useState} from 'react'
import $ from 'jquery'
import Style from './defaultmapping.module.css'
import API from '../../../../../API/API';
import DeleteMapping from '../DeleteMapping/DeleteMapping';
const DefaultMappingTable = (props) => {
    const [checked, setChecked] = useState(false);
    const [defaultMappings, setDefaultMappings] = useState()
    const [sourceMethods, setSourceMethods] = useState([])
    const [targetMethods, setTargetMethods] = useState([])
    useEffect(() => {
        var response =window.localStorage.getItem("accessToken") ;
        const headers={
            "authorization": `Bearer ${response}`,
            "content-type" : "application/json"
        };
        API.get(`/Warehouse/erp/${props.instancesId}/${props.targetId}`, {headers})
        .then((response)=>{
            if(response.status === 200){
                setSourceMethods(response.data)
            }
        })
        API.get(`/Warehouse/ecommerce/${props.instancesId}/${props.targetId}`, {headers})
        .then((response) => {
            if(response.status === 200){
                setTargetMethods(response.data)
            }
        })
        API.get(`/Connection/${props.connectorId}/instance/${props.instancesId}/location-mappings`,{headers})
        .then((response) => {
            if(response.status === 200){
                setDefaultMappings(response.data)
            }
        })
    },[])

    const updateMethod = (event) =>{
        if(event.target.checked === true){
            $(event.target).closest("td").attr("headers", "true")
        }else if(event.target.checked === false){
            $(event.target).closest("td").attr("headers", "false")
        }else{
            $(event.target).closest("td").attr("headers", event.target.value)
        }
    }

    console.log("Verify Mapping", props.newlyAddedMapping && props.newlyAddedMapping)
    return (
        <>
            <div className={Style.mappingtableContainer}>
                <table id='multiLocationMappingTable' width={"100%"} className='tableAlign'>
                    {
                        props.newlyAddedMapping && props.newlyAddedMapping.map((item, index) => 
                            <tr> 
                                <td className={Style.selecterptd} headers={item.ErpLocationId}>
                                    <select className='form-control sourceMethod' onChange={updateMethod}>
                                        <option value={item.ErpLocationId}> {item.ErpMethod}  </option>
                                        {
                                            sourceMethods && sourceMethods.map(item1 => 
                                                item.erpMethod != item1.value ?
                                                    <option value={item1.value}> {item1.name} </option>
                                                : null
                                            )
                                        }
                                    </select>
                                </td>
                                <td className={Style.selectecommercetd} headers={item.EcommerceLocationId}> 
                                    <select className='form-control sourceMethod' onChange={updateMethod}>
                                        <option value={item.EcommerceLocationId} > {item.EcommerceMethod}   </option>
                                        {
                                            targetMethods && targetMethods.map(item1 => 
                                                item.ecommerceMethod != item1.value ?
                                                   <option value={item1.value}> {item1.name} </option>
                                                : null
                                            )
                                        }
                                    </select>
                                </td>
                                <td colSpan={2} headers={item.isDefault ? "true" : "false"}> 
                                    <div className="form-check mAuto">
                                        <input 
                                            className="custom-control-input form-check-input" 
                                            type="checkbox" 
                                            id={"locationIsDefault"+index} 
                                            defaultChecked={item.IsDefault}
                                            onChange={updateMethod}
                                        />
                                        <label className="custom-control-label form-check-label" for={"locationIsDefault"+index}>
                                            Is Default ?
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    <DeleteMapping />
                                </td>
                            </tr>
                        )
                    }
                    {
                        defaultMappings && defaultMappings.map((item, index) =>
                            <tr>
                                <td className={Style.selecterptd} headers={item.erpLocationId}>
                                    <select className='form-control sourceMethod' onChange={updateMethod}>
                                        <option value={item.erpLocationId}> {item.erpMethod}  </option>
                                        {
                                            sourceMethods && sourceMethods.map(item1 => 
                                                <option value={item1.value}> {item1.name} </option>
                                            )
                                        }
                                    </select>
                                </td>
                                <td className={Style.selectecommercetd} headers={item.ecommerceLocationId}> 
                                    <select className='form-control sourceMethod' onChange={updateMethod}>
                                        <option value={item.ecommerceLocationId} > {item.ecommerceMethod}   </option>
                                        {
                                            targetMethods && targetMethods.map(item1 => 
                                                <option value={item1.value}> {item1.name} </option>
                                            )
                                        }
                                    </select>
                                </td>
                                <td colSpan={2} headers={item.isDefault ? "true" : "false"}>
                                    <div className="form-check mAuto">
                                        <input 
                                            className="custom-control-input form-check-input" 
                                            type="checkbox" 
                                            id={"locationIsDefault"+index} 
                                            defaultChecked={item.isDefault}
                                            onChange={updateMethod}
                                        />
                                        <label className="custom-control-label form-check-label" for={"locationIsDefault"+index}>
                                            Is Default ?
                                        </label>
                                    </div>
                                </td>
                                <td>
                                    <DeleteMapping />
                                </td>
                            </tr>
                        )
                    }
                </table>
            </div>
        </>
    )
}

export default DefaultMappingTable
